// Gemeinsame Typen des Teilsystems Aufgaben (Bereich `aufgaben`). Gehört dem Tab „Aufgaben“.
export const AUFGABEN_STATUS = ['offen', 'in_arbeit', 'wartet', 'erledigt'];
export const STATUS_NAMEN = {
    offen: 'Offen',
    in_arbeit: 'In Arbeit',
    wartet: 'Wartet',
    erledigt: 'Erledigt',
};
export const PRIORITAETEN = ['niedrig', 'normal', 'hoch'];
export const PRIORITAET_NAMEN = {
    niedrig: 'Niedrig',
    normal: 'Normal',
    hoch: 'Hoch',
};
export const QUELLEN = ['mail', 'hand', 'ki', 'mindmap'];
/** Heutiges Datum (JJJJ-MM-TT) in deutscher Zeit. */
export function heuteIso(jetzt = new Date()) {
    return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(jetzt);
}
export function istUeberfaellig(a, heute = heuteIso()) {
    return !!a.faellig && a.status !== 'erledigt' && a.faellig < heute;
}
/** Ganze Tage zwischen zwei ISO-Daten (b − a). */
export function tageZwischen(a, b) {
    return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000);
}
//# sourceMappingURL=aufgaben.js.map